/**
 * 文件说明:
 *
 * Page Breadcrumb title  Header
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {memo, useLayoutEffect, useState} from 'react'
import ContentHeader from 'components/hz-layout/content-header'
import classnames from 'classnames'
import {useRefData} from 'hooks'
import {cloneDeep} from 'lodash'
import styles from './index.less'

const BreadcrumbHeader = memo((props) => {
    const {
        pageHeaderOption: initPageHeaderOption,
        setHzHeaderHelp,
        PageComponent,
        pageProps,
        restoreHzHeaderHelp,
        useTitle,
    } = props

    const [pageHeaderOption, setPageHeaderOption] = useState(() => {
        const newPageHeaderOption = cloneDeep(initPageHeaderOption ?? {})

        const lastItem = newPageHeaderOption?.content?.[newPageHeaderOption?.content?.length - 1]
        if (lastItem) {
            if (typeof lastItem?.name === 'function') {
                lastItem.name = lastItem.name({
                    pageProps,
                    pageHeaderOption: newPageHeaderOption,
                })
            }
            lastItem.className = classnames(styles.lastBreadcrumbItem, lastItem.className)
        }

        if (typeof newPageHeaderOption?.title === 'function') {
            newPageHeaderOption.title = newPageHeaderOption.title({
                pageProps,
                pageHeaderOption: newPageHeaderOption,
            })
        }

        return newPageHeaderOption
    })

    const {title, defaultTitle, hzHelp, autoCrateComponent = false, ...restProps} = pageHeaderOption

    const hzDocTitle = useTitle(title, defaultTitle)

    const getRefData = useRefData({
        setHzHeaderHelp,
        restoreHzHeaderHelp,
        hzHelp,
    })

    useLayoutEffect(() => {
        getRefData()?.setHzHeaderHelp?.(getRefData()?.hzHelp)
        return () => {
            getRefData()?.restoreHzHeaderHelp?.()
        }
    }, [])

    if (autoCrateComponent) {
        return (
            <PageComponent
                {...pageProps}
                hzDocTitle={hzDocTitle}
                setHzHeaderHelp={setHzHeaderHelp}
                restoreHzHeaderHelp={restoreHzHeaderHelp}
                pageHeaderOption={pageHeaderOption}
                setPageHeaderOption={setPageHeaderOption}
                ContentHeader={ContentHeader}
                contentHeaderOption={{...restProps}}
            />
        )
    }

    return (
        <>
            <ContentHeader {...restProps} />
            <PageComponent
                {...pageProps}
                hzDocTitle={hzDocTitle}
                setHzHeaderHelp={setHzHeaderHelp}
                restoreHzHeaderHelp={restoreHzHeaderHelp}
                pageHeaderOption={pageHeaderOption}
                setPageHeaderOption={setPageHeaderOption}
            />
        </>
    )
})

export default BreadcrumbHeader
